module.exports = require('./helpers/bundle-url').getBundleURL('f34WS') + "logo-dark.eefe0b7f.svg";